import { render, staticRenderFns } from "./BlogArticle.vue?vue&type=template&id=171ef342&scoped=true"
import script from "./BlogArticle.vue?vue&type=script&lang=js"
export * from "./BlogArticle.vue?vue&type=script&lang=js"
import style0 from "./BlogArticle.vue?vue&type=style&index=0&id=171ef342&prod&lang=scss&scoped=true"
import style1 from "./BlogArticle.vue?vue&type=style&index=1&id=171ef342&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171ef342",
  null
  
)

export default component.exports